import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { SchedulerStudentPlanQuery } from '../../../search_and_add_courses/queries/scheduler_student_plan_query';

export type TSaveCoReqCourseToTermAP3Command = (courseId: number, termId: number) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'saveCoReqCourseToTermAP3Command',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngSchedulerStudentPlanQuery: SchedulerStudentPlanQuery
    ): ICommand => {
      return defineCommandORM('saveCoReqCourseToTermAP3Command', (deferred, courseId: number, termId: number) => {
        if (!ngSchedulerStudentPlanQuery.result) {
          return deferred.reject();
        }
        const payload = {
          course: courseId,
          met_aside_from_term: false,
          term: termId,
          kind: 'Planned Course'
        };

        return $http
          .post(`/ap3/studentplans/${ngSchedulerStudentPlanQuery.result.id}/studentplanitems-infer-term/`, payload)
          .catch(deferred.reject)
          .then(() => deferred.resolve());
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/commands/save_coreq_course_to_term_ap3_command.ts